export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/PT-ed81f3769a9cb278f0795e5e18cabbe3.png";